<app-section-quick-actions section="realm" />

@if (realm) {
<header class="atmos-page__header">
  <h1 class="atmos-page__title">{{ realm.name }}</h1>
</header>

<section class="atmos-card atmos-realm__summary">
  <div class="atmos-summary__grid" [class.atmos-realm__summary--no-media]="!realm.imageUrl">
    <div class="atmos-card__body atmos-summary__main">
      <div class="atmos-facts">
        @if (realm.areas?.length) {
          <div class="atmos-fact">
            <div class="atmos-fact__label">Areas</div>
            <div class="atmos-fact__value">
              <mat-icon class="atmos-fact__icon">location_on</mat-icon>
              <span class="atmos-fact__text">{{ realm.areas!.length }}</span>
            </div>
          </div>
        }

        @if (realm.elder; as elder) {
          <div class="atmos-fact">
            <div class="atmos-fact__label">Elder</div>
            <a class="atmos-fact__value" [routerLink]="['/spirit', elder.guid]">
              <app-spirit-type-icon type="Elder"></app-spirit-type-icon>
              <span class="atmos-fact__text atmos-text-link">{{ elder.name }}</span>
            </a>
          </div>
        }

        @if (spiritCount) {
          <div class="atmos-fact">
            <div class="atmos-fact__label">Spirits</div>
            <a class="atmos-fact__value" routerLink="/spirit" [queryParams]="{ type: 'Regular,Elder', realm: realm.guid }">
              <app-spirit-type-icon type="Regular"></app-spirit-type-icon>
              <span class="atmos-fact__text atmos-text-link">{{ spiritCount }}</span>
            </a>
          </div>
        }

        @if (seasonSpiritCount || seasonGuideCount) {
          <div class="atmos-fact">
            <div class="atmos-fact__label">Season spirits</div>
            <a class="atmos-fact__value" routerLink="/spirit" [queryParams]="{ type: 'Season,Guide', realm: realm.guid }">
              <app-spirit-type-icon type="Season"></app-spirit-type-icon>
              <span class="atmos-fact__text atmos-text-link">{{ seasonSpiritCount }}@if (seasonGuideCount) { (+{{ seasonGuideCount }} guide{{ seasonGuideCount > 1 ? 's' : '' }})}</span>
            </a>
          </div>
        }
      </div>
    </div>

    @if (realm.imageUrl) {
      <div class="atmos-summary__preview"
        [style.background-image]="'url(' + realm.imageUrl + ')'"
        [style.background-position]="realm.imagePosition || null"></div>
    }
  </div>

  @if (realm._wiki?.href; as wikiHref) {
    <div class="atmos-summary__actions">
      <a class="atmos-summary__action" [href]="wikiHref" target="_blank" rel="noopener">
        <mat-icon>open_in_new</mat-icon>
        <span>Wiki</span>
      </a>
    </div>
  }
</section>

<!-- Constellation + progress -->
@if (realm.constellation) {
  <section class="atmos-realm__constellation-row">
    <div class="atmos-card atmos-realm__progress">
      <div class="atmos-card__body">
        <h2 class="atmos-realm__progress-title">Constellation</h2>
        <div class="atmos-realm__tier">
          <span class="atmos-realm__tier-label">Tier 1</span>
          <div class="atmos-realm__tier-grid">
            <mat-icon class="currency" svgIcon="candle"></mat-icon>
            <div class="atmos-realm__bar" [class.is-full]="tier1Pct.c === 100">
              <div class="atmos-realm__bar-fill" [style.width.%]="tier1Pct.c || 0"></div>
              <div class="atmos-realm__bar-text">
                {{ tier1Remaining.c || 0 }} left / {{ tier1Cost.c || 0 }}
                <span class="atmos-realm__bar-pct">({{ (tier1Spent.c || 0) | percentage:0:(tier1Cost.c || 0) }}%)</span>
              </div>
            </div>
            <mat-icon class="currency" svgIcon="heart"></mat-icon>
            <div class="atmos-realm__bar" [class.is-full]="tier1Pct.h === 100">
              <div class="atmos-realm__bar-fill" [style.width.%]="tier1Pct.h || 0"></div>
              <div class="atmos-realm__bar-text">
                {{ tier1Remaining.h || 0 }} left / {{ tier1Cost.h || 0 }}
                <span class="atmos-realm__bar-pct">({{ (tier1Spent.h || 0) | percentage:0:(tier1Cost.h || 0) }}%)</span>
              </div>
            </div>
            <mat-icon class="currency" svgIcon="ascended-candle"></mat-icon>
            <div class="atmos-realm__bar" [class.is-full]="tier1Pct.ac === 100">
              <div class="atmos-realm__bar-fill" [style.width.%]="tier1Pct.ac || 0"></div>
              <div class="atmos-realm__bar-text">
                {{ tier1Remaining.ac || 0 }} left / {{ tier1Cost.ac || 0 }}
                <span class="atmos-realm__bar-pct">({{ (tier1Spent.ac || 0) | percentage:0:(tier1Cost.ac || 0) }}%)</span>
              </div>
            </div>
          </div>
        </div>

        @if (tier2Cost.ac) {
          <div class="atmos-realm__tier">
            <span class="atmos-realm__tier-label">Tier 2</span>
            <div class="atmos-realm__tier-grid">
              @if (tier2Cost.c) {
                <mat-icon class="currency" svgIcon="candle"></mat-icon>
                <div class="atmos-realm__bar" [class.is-full]="tier2Pct.c === 100">
                  <div class="atmos-realm__bar-fill" [style.width.%]="tier2Pct.c || 0"></div>
                  <div class="atmos-realm__bar-text">
                    {{ tier2Spent.c || 0 }} / {{ tier2Cost.c || 0 }}
                    <span class="atmos-realm__bar-pct">({{ (tier2Spent.c || 0) | percentage:0:(tier2Cost.c || 0) }}%)</span>
                  </div>
                </div>
              }
              @if (tier2Cost.h) {
                <mat-icon class="currency" svgIcon="heart"></mat-icon>
                <div class="atmos-realm__bar" [class.is-full]="tier2Pct.h === 100">
                  <div class="atmos-realm__bar-fill" [style.width.%]="tier2Pct.h || 0"></div>
                  <div class="atmos-realm__bar-text">
                    {{ tier2Spent.h || 0 }} / {{ tier2Cost.h || 0 }}
                    <span class="atmos-realm__bar-pct">({{ (tier2Spent.h || 0) | percentage:0:(tier2Cost.h || 0) }}%)</span>
                  </div>
                </div>
              }
              @if (tier2Cost.ac) {
                <mat-icon class="currency" svgIcon="ascended-candle"></mat-icon>
                <div class="atmos-realm__bar" [class.is-full]="tier2Pct.ac === 100">
                  <div class="atmos-realm__bar-fill" [style.width.%]="tier2Pct.ac || 0"></div>
                  <div class="atmos-realm__bar-text">
                    {{ tier2Spent.ac || 0 }} / {{ tier2Cost.ac || 0 }}
                    <span class="atmos-realm__bar-pct">({{ (tier2Spent.ac || 0) | percentage:0:(tier2Cost.ac || 0) }}%)</span>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <app-realm-constellation
      [realm]="realm"
      [realms]="visibleRealms"
      [completed]="!tier1Remaining.c && !tier1Remaining.h && !tier1Remaining.ac"
      (spiritClicked)="constellationSpiritClicked($event)"
      (realmChanged)="constellationRealmChanged($event)">
    </app-realm-constellation>
  </section>
}


@if (realm.areas?.length) {
  <section class="atmos-page__section">
    <h2 class="atmos-section__title">Areas</h2>
    <div class="atmos-realm__areas">
      @for (area of realm.areas; track area.guid) {
        <app-feature-card
          [title]="area.name"
          [titleLink]="'/area/' + area.guid"
          [bannerUrl]="area.imageUrl"
          [bannerPosition]="area.imagePosition"
          [links]="areaLinks(area)" />
      }
    </div>
  </section>
}

@if (spirits.length) {
  <section class="atmos-card atmos-realm__trees" #divSpiritTrees>
    <div class="atmos-card__body atmos-realm__trees-body">
      <h2 class="atmos-section__title">Spirit trees</h2>
      <div class="atmos-spirit-trees atmos-realm__trees-scroll">
        @for (data of spirits; track data.spirit.guid) {
          <div class="atmos-realm__tree-wrapper">
            <app-spirit-tree [tree]="data.tree" [name]="data.spirit.name"
              [nameLink]="['/spirit', data.spirit.guid]" [nameQueryParams]="{ highlightTree: data.tree.guid }"
              [highlight]="highlightTree === data.tree.guid"></app-spirit-tree>
          </div>
        }
      </div>
    </div>
  </section>
}
}
